import React from 'react';

const CTA = () => {
  return (
    <section className="py-16 bg-[#121212] text-white text-center flex flex-col items-center justify-center px-4">
      <div className="w-full max-w-3xl rounded-2xl border border-white/10 bg-[#171717] px-6 py-8 shadow-lg md:px-8 md:py-10">
        <p className="text-xs uppercase tracking-[0.2em] text-blue-400 mb-3">
          Built for focused traders
        </p>

        <h2 className="text-2xl md:text-3xl font-bold mb-4 tracking-tight">
          Explore a Smarter Trading Workflow.
        </h2>

        <p className="text-sm md:text-base text-gray-400 max-w-2xl mx-auto leading-8">
          Built for traders who want cleaner structure, better discipline, and
          sharper decisions through risk analysis, journaling, and premium trade
          evaluation tools.
        </p>

        <p className="text-xs md:text-sm text-gray-500 mt-5">
          Designed to help traders stay organized, consistent, and intentional.
        </p>
      </div>
    </section>
  );
};

export default CTA;